// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"396":"31b19b91","401":"8a4313dc","453":"125b7c51","657":"c7142ac5","905":"96da16d7"}[chunkId] + ".chunk.js";
};